<mat-tab-group mat-align-tabs="center">

  <!-- Tab: Benachrichtigungen -->
  <mat-tab label="Benachrichtigungen">
    <div class="tab-content">
      <p class="tab-description">Verwalte deine Push-Benachrichtigungen.</p>
      <button
        mat-raised-button
        color="primary"
        class="settings-btn"
        (click)="tryRegisterPushNoti()"
        [disabled]="messagingService.isRequestingToken | async"
      >
        <mat-icon *ngIf="!(messagingService.isRequestingToken | async)">notifications</mat-icon>
        <mat-spinner *ngIf="messagingService.isRequestingToken | async" diameter="20" class="btn-spinner"></mat-spinner>
        Benachrichtigungen empfangen
      </button>
    </div>
  </mat-tab>

  <!-- Tab: Protokoll -->
  <mat-tab label="Protokoll">
    <div class="tab-content">
      <p class="tab-description">Sende oder lösche die lokalen Log-Dateien.</p>
      <button
        mat-raised-button
        color="primary"
        class="settings-btn"
        (click)="sendLogsToDev()"
      >
        <mat-icon>send</mat-icon>
        Log-files senden
      </button>
      <button
        mat-raised-button
        color="warn"
        class="settings-btn"
        (click)="clearLogs()"
      >
        <mat-icon>delete_outline</mat-icon>
        Log-files löschen
      </button>
    </div>
  </mat-tab>

</mat-tab-group>
